var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-summary" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            {
              staticClass: "d-none d-md-inline-block",
              attrs: { xs: 24, sm: 24, md: 10 },
            },
            [
              _c("div", [
                _c("b", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("general.validOrders")) +
                      ": " +
                      _vm._s(
                        _vm.$selectedOrders.filter(function (order) {
                          return !this$1.isInvalidOrder(order)
                        }).length
                      ) +
                      " / " +
                      _vm._s(_vm.getCurrentTruckOrders) +
                      " "
                  ),
                ]),
              ]),
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("planning.tooltip.carton")) +
                    ": " +
                    _vm._s(
                      _vm.helper.sumBy(
                        _vm.$selectedOrders.filter(function (order) {
                          return !this$1.isInvalidOrder(order)
                        }),
                        function (o) {
                          return parseInt(o.cartons || 0)
                        }
                      )
                    ) +
                    " / " +
                    _vm._s(_vm.getCurrentTruckOrdersField("cartons")) +
                    " "
                ),
              ]),
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("planning.tooltip.pallet")) +
                    ": " +
                    _vm._s(
                      _vm.helper.sumBy(
                        _vm.$selectedOrders.filter(function (order) {
                          return !this$1.isInvalidOrder(order)
                        }),
                        function (o) {
                          return parseInt(o.pallets || 0)
                        }
                      )
                    ) +
                    " / " +
                    _vm._s(_vm.getCurrentTruckOrdersField("pallets")) +
                    " "
                ),
              ]),
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("planning.tooltip.others")) +
                    ": " +
                    _vm._s(
                      _vm.helper.sumBy(
                        _vm.$selectedOrders.filter(function (order) {
                          return !this$1.isInvalidOrder(order)
                        }),
                        function (o) {
                          return parseInt(o.others || 0)
                        }
                      )
                    ) +
                    " / " +
                    _vm._s(_vm.getCurrentTruckOrdersField("others")) +
                    " "
                ),
              ]),
              _vm.hasAssemblyMinutes
                ? [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("planning.columns.wallMountQuantity")) +
                          ": " +
                          _vm._s(
                            _vm.helper.sumBy(
                              _vm.$selectedOrders.filter(function (order) {
                                return !this$1.isInvalidOrder(order)
                              }),
                              function (o) {
                                return parseInt(o.wallMountQuantity || 0)
                              }
                            )
                          ) +
                          " / " +
                          _vm._s(
                            _vm.getCurrentTruckOrdersField("wallMountQuantity")
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("planning.columns.disposalQuantity")) +
                          ": " +
                          _vm._s(
                            _vm.helper.sumBy(
                              _vm.$selectedOrders.filter(function (order) {
                                return !this$1.isInvalidOrder(order)
                              }),
                              function (o) {
                                return parseInt(o.disposalQuantity || 0)
                              }
                            )
                          ) +
                          " / " +
                          _vm._s(
                            _vm.getCurrentTruckOrdersField("disposalQuantity")
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("planning.columns.staircaseQuantity")) +
                          ": " +
                          _vm._s(
                            _vm.helper.sumBy(
                              _vm.$selectedOrders.filter(function (order) {
                                return !this$1.isInvalidOrder(order)
                              }),
                              function (o) {
                                return parseInt(o.staircaseQuantity || 0)
                              }
                            )
                          ) +
                          " / " +
                          _vm._s(
                            _vm.getCurrentTruckOrdersField("staircaseQuantity")
                          ) +
                          " "
                      ),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 14 } },
            [
              _c("div", [
                _c(
                  "b",
                  [
                    _vm._v(" " + _vm._s(_vm.$t("planning.tooltip.gw")) + ": "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("planning.validSelectedOrders"),
                          placement: "top",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.helper.printThousandDecimal(
                                _vm.getSelectedOrderCapacity("weight")
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" + "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("planning.validTruckOrders"),
                          placement: "top",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.getCurrentTruckOrdersField("weight"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" / "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("planning.totalTruckCapacity"),
                          placement: "top",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.helper.printThousandDecimal(
                                _vm.helper.get(_vm.currTruck, "weight", 0)
                              )
                            ) + " KG"
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                [
                  _c("el-progress", {
                    attrs: {
                      "text-inside": true,
                      "stroke-width": 18,
                      percentage: _vm.percentage("gw"),
                      color: _vm.percentageColor("gw"),
                    },
                  }),
                ],
                1
              ),
              _c("br"),
              _c("div", [
                _c(
                  "b",
                  [
                    _vm._v(" " + _vm._s(_vm.$t("planning.tooltip.cbm")) + ": "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("planning.validSelectedOrders"),
                          placement: "top",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.helper.printThousandDecimal(
                                _vm.getSelectedOrderCapacity("volume")
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" + "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("planning.validTruckOrders"),
                          placement: "top",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.getCurrentTruckOrdersField("volume"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" / "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("planning.totalTruckCapacity"),
                          placement: "top",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.helper.printThousandDecimal(
                                _vm.helper.get(_vm.currTruck, "volume", 0)
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                [
                  _c("el-progress", {
                    attrs: {
                      "text-inside": true,
                      "stroke-width": 18,
                      percentage: _vm.percentage("cbm"),
                      color: _vm.percentageColor("cbm"),
                    },
                  }),
                ],
                1
              ),
              _vm.hasAssemblyMinutes
                ? [
                    _c("br"),
                    _c("div", [
                      _c(
                        "b",
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("planning.tooltip.workingHours")) +
                              ": "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.$t("planning.validSelectedOrders"),
                                placement: "top",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.helper.printThousandDecimal(
                                      _vm.getSelectedOrderCapacity(
                                        "assemblyMinutes"
                                      )
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" + "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.$t("planning.validTruckOrders"),
                                placement: "top",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getCurrentTruckOrdersField(
                                      "assemblyMinutes"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" / "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.$t("planning.totalTruckCapacity"),
                                placement: "top",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.helper.printThousandDecimal(
                                      _vm.helper.get(
                                        _vm.currTruck,
                                        "assemblyMinutes",
                                        0
                                      )
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      [
                        _c("el-progress", {
                          attrs: {
                            "text-inside": true,
                            "stroke-width": 18,
                            percentage: _vm.percentage("time"),
                            color: _vm.percentageColor("time"),
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm.$selectedOrders.length > 0
            ? _c(
                "el-col",
                {
                  staticClass: "mt-2 ml-3 mr-3 mb-1 cursor-pointer",
                  attrs: { xs: 24 },
                  nativeOn: {
                    click: function ($event) {
                      _vm.isShowDetails = !_vm.isShowDetails
                    },
                  },
                },
                [
                  _c("b", [
                    _c("i", [_vm._v(_vm._s(_vm.$t("general.showDetails")))]),
                  ]),
                  _c("font-awesome-icon", {
                    staticClass: "float-right caret",
                    class: { open: _vm.isShowDetails },
                    attrs: { icon: "caret-down" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowDetails
            ? _c(
                "el-col",
                { staticClass: "mt-1" },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: { size: "small" },
                      model: {
                        value: _vm.groupedBy,
                        callback: function ($$v) {
                          _vm.groupedBy = $$v
                        },
                        expression: "groupedBy",
                      },
                    },
                    _vm._l(_vm.groupedByFilters, function (filter, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.$t("planning.columns." + filter),
                          value: filter,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowDetails
            ? _c(
                "el-col",
                { staticClass: "mt-2" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        size: "mini",
                        border: "",
                        data: _vm.groupedOrders,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("general.groupedBy"),
                          prop: "key",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("general.totalOrders"),
                          prop: "count",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("planning.tooltip.gw"),
                          prop: "gw",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("planning.tooltip.cbm"),
                          prop: "cbm",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }